import React from "react";
import withStyles from "react-jss";
import Button from "ComponentsUI/Button";
import { Link } from "react-router-dom";

const styles = (theme) => {
	return {
		root: {
			backgroundColor: theme.palette.colors.white,
			borderRadius: "10px",
			border: `1px solid ${theme.palette.colors.cloudyBlue}`,
			width: "100%",
			height: "100%",
			padding: "30px",
			position: "relative",
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
		},
		header: {
			fontFamily: theme.fonts.bold,
			fontSize: "24px",
			lineHeight: 1,
			color: theme.palette.colors.darkSlateBlue,
			marginBottom: "20px",
		},
		buttonWrapper: {
			position: "relative",
			zIndex: 1,
		},
		text: {
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			lineHeight: 1.25,
			maxWidth: "360px",
			color: theme.palette.colors.darkSlateBlue,
			marginBottom: "20px",
		},
		image: {
			position: "absolute",
			width: "220px",
			bottom: 0,
			right: 0,
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			text: {
				maxWidth: "246px",
			},
			buttonWrapper: {
				marginTop: "auto",
			},
			image: {
				width: "250px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				padding: "20px",
			},
			text: {
				maxWidth: "205px",
			},
			header: {},
			buttonWrapper: {
				marginTop: "auto",
			},
			image: {
				width: "250px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				padding: "20px",
			},
			text: {
				maxWidth: "50%",
				fontSize: "14px",
			},
			header: {
				fontSize: "18px",
			},
			buttonWrapper: {
				marginTop: "auto",
			},
			image: {
				width: "70%",
				maxWidth: "225px",
			},
		},
	};
};

class AddReviewBlock extends React.Component {
	render() {
		let text = this.props.text;
		let classes = this.props.classes;
		return (
			<div className={classes.root}>
				<div className={classes.header}>{text.ADD_REVIEW_FORM_HEADER}</div>
				<div className={classes.text}>{text.ADD_REVIEW_FORM_TEXT}</div>
				<div className={classes.buttonWrapper}>
					<Button
						component={<Link to={!!this.props.link ? this.props.link : "/"} />}
						typeText="bannerText"
						size="middle"
						status="active"
					>
						{text.ratingLeaveReview}
					</Button>
				</div>
				<img className={classes.image} alt={"support"} src={require("icons/support.png")} />
			</div>
		);
	}
}

export default withStyles(styles)(AddReviewBlock);
